import React from "react";
import { Form, Select, Button } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

export const FormList = ({ councilBodyList = [], jabatanOptions = [] }) => {
  return (
    <>
      <Form.List name="councilBody">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <div
                key={key}
                style={{
                  border: "1px solid #f0f0f0",
                  padding: 16,
                  marginBottom: 12,
                  borderRadius: 8,
                  position: "relative",
                  background: "#fafafa",
                }}
              >
                <div style={{ marginBottom: 8, fontWeight: 500 }}>
                  AKD {index + 1}
                </div>

                <div style={{ display: "flex", gap: 12 }}>
                  <Form.Item
                    {...restField}
                    name={[name, "councilBody_id"]}
                    style={{ flex: 1 }}
                    rules={[{ required: true, message: "Pilih AKD" }]}
                  >
                    <Select placeholder="Pilih AKD">
                      {councilBodyList.map((i) => (
                        <Select.Option key={i.value} value={i.value}>
                          {i.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, "position"]}
                    style={{ flex: 1 }}
                    rules={[{ required: true, message: "Pilih posisi" }]}
                  >
                    <Select placeholder="Pilih Posisi">
                      {jabatanOptions.map((item) => (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                <MinusCircleOutlined
                  onClick={() => remove(name)}
                  style={{
                    position: "absolute",
                    top: 16,
                    right: 16,
                    color: "red",
                  }}
                />
              </div>
            ))}

            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Tambah AKD
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </>
  );
};
